import { Col, Drawer, Popover, Row, Tooltip } from "antd";
import React, { Fragment, useState } from "react";
import Phoneicon from "../../../assets/images/PhoneIcon.svg";
import MailIcon from "../../../assets/images/EmailIcon.svg";
import { ClockIcon, EditPennIcon, EmailIcon, LocationIcon, PhoneIcon, NumbersIcon, NoteIcon } from "../../common/CustomIcon";
import AddressInfo from "../../components/common/AddressInfo";
import Button_v2 from "./Button_v2";
import noImg from "../../../assets/images/noImg.png";
import OrderDetailsDrawer from "./OrderDetailsDrawer";
import { checkNegitive, ellipseText, findTotal } from "../../common/Common";
import { roundToDecimals, checkAccessExistance } from "../../helpers/common";

function parseValidNumber(input) {
  const str = String(input).trim();

  const regex = /^[-+]?(?:(\d{1,3})(?:,\d{3})+|\d+)(?:\.\d+)?$/;

  if (!regex.test(str)) {
    return 0;
  }

  const numericValue = parseFloat(str.replace(/,/g, ''));
  return isNaN(numericValue) ? 0 : numericValue;
}

function OrderAmountSummary(props) {
  const { account, orderResponse, refreshDetails ,showDrawer, setShowDrawer, viewTab, setViewTab, isShipper = false } = props;
  const emptyText = 'Not available'
  const renderDrawerDetails = (view) => {
    if(view === "quote" && orderResponse?.customer_order_details?.quote_id || ["estimate", "invoice"].includes(view)){
      setShowDrawer(true)
      setViewTab(view)
    }
  }

  const totalDistance = orderResponse.type_of_order == "LH" ? (orderResponse?.customer_order_details?.distance || 0) : orderResponse.locations?.reduce((sum, item) => sum + parseValidNumber(item.distance), 0);
  const roundOffDecimalsForDistance = 2;
  const accountContent = (
    <div>
        <div className="content-div">
            <Row gutter={[8, 8]} align="middle" type="flex">
                <Col>
                    <EmailIcon />
                </Col>
                <Col className="text-blue text-col">{account.email || emptyText}</Col>
            </Row>
            <Row gutter={[8, 8]} align="middle" type="flex">
                <Col>
                    <LocationIcon />
                </Col>
                <Col className="text-blue">{account?.address ? <AddressInfo address={account.address} /> : ''}</Col>
            </Row>
            <Row gutter={[8, 8]} align="middle" type="flex">
                <Col>
                <PhoneIcon />
                </Col>
                <Col className="text-blue">{account.phone_number || 'N/A'}</Col>
            </Row>
            <Row gutter={[8, 8]} align="middle" type="flex">
                <Col>
                    <ClockIcon />
                </Col>
                <Col>8AM - 8PM ET</Col>
            </Row>
            <Row gutter={[8, 8]} align="middle" type="flex">
                <Col>
                    <NumbersIcon />
                </Col>
                <Col>{account.account_code || 'N/A'}</Col>
            </Row>
        </div>
        {!isShipper && checkAccessExistance('ACCOUNT_SETTINGS') && <div className="footer-div">
            <Row type="flex" gutter={16}>
                <Col>
                    <Button_v2
                        onClick={() => props.history.push(`/accounts/${account.id}/settings`)}
                        className="outline medium-btn"
                        text={
                            <>
                                <EditPennIcon color="#617AD6" />
                                <span>Manage</span>
                            </>
                        }
                        />
                </Col>
                {/* <Col>
                    <Button_v2
                        // onClick={() => setOpenModal(false)}
                        className="outline medium-btn"
                        text="View Assigned Orders"
                    />
                </Col> */}
            </Row>
        </div>}
    </div>
)

  return (
    <div className="shipment-card">
      <Row gutter={16} align="middle">
        <Popover
          overlayClassName="account-details-popover"
          trigger="hover"
          placement="top"
          title={
            <Row style={{ display: "flex", alignItems: "center",gap: "10px" }}>
              <Col>
                  <img
                    src={account?.logo_url ? account?.logo_url : noImg}
                    alt="logo"
                    style={{
                      width: "48px",
                      height: "48px",
                    }}
                  />
                
              </Col>
              <Col>
                <div className="title-div-1">{account.account_name}</div>
                <div className="title-div-2">
                  {account.contact || emptyText}
                </div>
              </Col>
              
            </Row>
          }
          content={accountContent}
        >
          <Col xs={24} sm={12} md={12} lg={12} className="company-info">
            <img src={account?.logo_url ? account?.logo_url : noImg} alt="Logo" className="company-logo" />
            <div>
              <div className="company-name">{account.account_name}</div>
              <div className="contact-info">
                <div className="contact-details">
                  <img src={Phoneicon} className="icon" alt="" />
                  <span className="address-items">{account?.phone_number || emptyText}</span>
                </div>

                <div className="contact-details">
                  <img src={MailIcon} className="icon" alt="" />
                  <span className="address-items">{account?.email || emptyText}</span>
                </div>
                 <div className="contact-details">
                  <Tooltip title="Shipper Notes">
                   <NoteIcon className="icon"/>
                  </Tooltip>
                    <span className="address-items">{orderResponse?.customer_order_details?.shipper_note?.trim() ? ellipseText(orderResponse?.customer_order_details?.shipper_note, 30, true) : 'No Notes'}</span>
                 </div>
              </div>
            </div>
          </Col>
        </Popover>
        <Col xs={24} sm={12} md={12} lg={12} className="shipment-details">
          <Row gutter={16} type="flex" justify='end'>
   
       <Col span={7} className="detail-item">
              <div className="detail-label">Weight</div>
              <div className="detail-value">
                {orderResponse.customer_order_details.weight
                  ? `${orderResponse.customer_order_details.weight} lbs / ${(orderResponse.customer_order_details.weight * 0.453592).toFixed(2)} kg`
                  : 'Not Available'}
              </div>
            </Col>

            <Col span={6} className="detail-item">
              <div className="detail-label">Items</div>
              <div className="detail-value">{orderResponse.customer_order_details.quantity || '0'}</div>
            </Col>

            <Col span={6} className="detail-item">
              <div className="detail-label">Distance</div>

              <div className="detail-value">
                {roundToDecimals((parseFloat(totalDistance) || 0),roundOffDecimalsForDistance)} mi
              </div>

            </Col>
            {/* <Col span={6} className="detail-item" 
               onClick={ () => {
                if (orderResponse?.customer_order_details?.quote_amount > 0) {
                  renderDrawerDetails("quote");
                }
              }} 
            >
              <div className="detail-label">Quote</div>
              <div className="detail-value text-blue">{checkNegitive(orderResponse?.customer_order_details?.quote_amount)}</div>
              {orderResponse?.customer_order_details?.quote_id && <ChevronRightIcon className="chevron-right" height="16" width="16" color="#576EC1" />}
            </Col> */}



            
          {/* {orderResponse?.status !== "COMPLETED" ? <Col span={6} className="detail-item"
             onClick={ () => {
              if (orderResponse?.customer_order_details?.quotation_amount > 0) {
                renderDrawerDetails("estimate");
              }
            }}            
            >
              <div className="detail-label">Estimate</div>
              <div className="detail-value text-blue">{checkNegitive(orderResponse?.customer_order_details?.quotation_amount)}</div>
             {orderResponse?.customer_order_details?.quotation_amount > 0 && <ChevronRightIcon className="chevron-right" height="16" width="16" color="#576EC1" />}
            </Col> :
            <Fragment>
            <Col span={6} className="detail-item" 
              onClick={ () => {
                if (orderResponse?.customer_order_details?.total_amount > 0) {
                  renderDrawerDetails("invoice");
                }
              }} 
            >
              <div className="detail-label">Billing</div>
              <div className="detail-value text-blue">{checkNegitive(orderResponse?.customer_order_details?.total_amount)}</div>
             {orderResponse?.customer_order_details?.total_amount > 0 && <ChevronRightIcon className="chevron-right" height="16" width="16" color="#576EC1" />}
            </Col>
            {orderResponse?.customer_order_details?.invoice_number && <Col span={6} className="detail-item" 
                onClick={ () => {
                  if (orderResponse?.customer_order_details?.invoice_number) {
                    renderDrawerDetails("invoice");
                  }
                }} 
              >
                <div className="detail-label">Invoice </div>
                <div className="detail-value text-blue">#{orderResponse.customer_order_details.invoice_number}</div>
                <ChevronRightIcon className="chevron-right" height="16" width="16" color="#576EC1" />
            </Col>}
              
            </Fragment>
            }*/}
          </Row>
        </Col>
      </Row>
      <Drawer
        visible={showDrawer}
        placement="right"
        closable={false}
        maskClosable={false}
        width={viewTab === "invoice" ? 1200 : 1000}
        className="order-details-drawer hide-scrollbar"
        destroyOnClose={true}
      >
        <OrderDetailsDrawer
          viewTab={viewTab}
          setShowDrawer={setShowDrawer}
          showDrawer={showDrawer}
          orderResponse={orderResponse}
          refreshDetails={refreshDetails}
          account={account}
        />
      </Drawer>
    </div>
  );
}

export default OrderAmountSummary;
